import tw, { styled, css } from 'twin.macro';

export const wrapper = styled.div(() => [
  css`
    ${tw`w-full  mt-40  mx-auto px-10 text-textBlack`};
    max-width: 75rem;
  `
]);
